import React from "react";

export function LoadingOverlay({ message = "در حال بارگذاری..." }) {
  return (
    <div className="absolute inset-0 z-10 flex items-center justify-center bg-app-surface/75 backdrop-blur-[1px]">
      <div className="flex flex-col items-center gap-2">
        <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-app-primary"></div>
        <span className="text-app-text-muted">{message}</span>
      </div>
    </div>
  );
}
